import React, { FunctionComponent } from "react"

import Seo from "../../components/Seo/Seo"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import ArtistItem from "./Item"
import Filters from "./Filters"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import { iArtist, iArtistQuery } from "../../definitions/Artists"
import { useData } from "../../hooks/useData"

import s from "./Artists.less"

const Artists: FunctionComponent = () => {
  const { total, data, loading, setQuery, query } = useData<
    iArtistQuery,
    iArtist
  >({
    link: "/v1/artists",
    defaultQuery: {},
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title={"Artists"} />
      <div className="content">
        <div className="content-header">
          <h1>Artists ({total})</h1>
          <Filters setQuery={setQuery} query={query} />
        </div>
        {loading ? (
          <Loader />
        ) : data.length ? (
          <div className={`grid-wrap ${s.gridWrap}`}>
            <Grid>
              {data.map((d, i) => (
                <LinkItem key={i} url={"/artists/" + d.url}>
                  <ArtistItem {...d} />
                </LinkItem>
              ))}
            </Grid>
          </div>
        ) : (
          <div className="no-data">No matching results.</div>
        )}
        <Pagination total={total} limit={50} setQuery={setQuery} />
      </div>
    </>
  )
}

export default Artists
